<template>
  <!-- <div class="head">
    <el-menu :default-active="activeIndex" class="dvmsmenu" mode="horizontal" @select="handleSelect">
      <el-menu-item class="menuitem"  index="1">团队介绍</el-menu-item>
      <el-menu-item class="menuitem" index="2">方法介绍</el-menu-item>
      <el-menu-item class="menuitem" index="3">数据中心</el-menu-item>
      <el-menu-item class="menuitem" index="4">团队成果</el-menu-item>
      <el-menu-item class="menuitem" index="5">下载</el-menu-item>
    </el-menu>
  </div> -->

  <div class="headerback">
    <div class="headerleft">
      <!-- <router-link to="/index"> -->
      
      <div class="hearderlogo" style="display:flex;position: relative;height:50%;">
        <img src="../assets/PCFDlogo1.png" alt="Logo" style="vertical-align: middle;height:100%; position: absolute;margin-top: 1vh;margin-bottom: 0.5vh;margin-left:1vh">
        <div class="title" >
                <span style="display: block; text-align: center;">
                    <strong>农产品碳足迹因子基准数据库</strong> <small>CAAS-CFAP</small>
                </span>
        </div>
        <div class="loginstate"  style="position: absolute;margin-top: 1vh;margin-bottom: 0.5vh;right:3vh">
          
          <el-tooltip v-if="($store.state.sessionLoginStatus === '1')"  placement="bottom"  effect="light">
            <div slot="content" class="logoutbutton" @click="logout()">退出登录</div>
            <img style="height:4vh;width:4vh" src="../assets/login.svg" alt="SVG图形">
          </el-tooltip>
          <img class="loginbutton" @click="login()" v-else style="height:4vh;width:4vh" src="../assets/unlogin.svg" alt="SVG图形">
        </div>
      </div>
      
      <!-- </router-link> -->
      <nav class="navbar" style="background-color: #1d466b; color: white;height:50%">
            <table style="width: 100%; border-collapse: collapse; ">
                <tr style="display: flex;justify-content: center;align-items: center;width:100%">  
                  <!-- <td><div class="tditem" @click="clicktd(1)" :class="{tditem_active:activeIndex==1}"><div :class="{a_active:activeIndex==1}" ><img src="../assets/about.png" alt="项目介绍图标" style="vertical-align: middle; ">项目介绍<br>About</div></div></td>
                  <td><div class="tditem" @click="clicktd(2)" :class="{tditem_active:activeIndex==2}"><div :class="{a_active:activeIndex==2}" ><img src="../assets/team.png" alt="团队图标" style="vertical-align: middle; ">团队成员<br>Contributors</div></div></td>
                  <td><div class="tditem" @click="clicktd(5)" :class="{tditem_active:activeIndex==5}"><div :class="{a_active:activeIndex==5}" ><img src="../assets/list.png" alt="成果列表图标" style="vertical-align: middle;">成果列表<br>News</div></div></td> -->
                  <td><div class="tditem" @click="clicktd(3)" :class="{tditem_active:activeIndex==3}"><div class="tditem_title" :class="{a_active:activeIndex==3}" >
                    <img src="../assets/news.png" alt="最新动态图标" style="vertical-align: middle;"><div><span style="letter-spacing: 0.2vh;">数据中心</span><br>Data Center</div>
                    </div></div></td> 
                  <td><div class="tditem" @click="clicktd(2)" :class="{tditem_active:activeIndex==2}"><div class="tditem_title"  :class="{a_active:activeIndex==2}" >
                    <img src="../assets/method.png" alt="方法介绍图标" style="vertical-align: middle; "><div><span style="letter-spacing: 0.2vh;">方法介绍</span><br>Methodology</div>
                    </div></div></td>
                  <td><div class="tditem" @click="clicktd(1)" :class="{tditem_active:activeIndex==1}"><div class="tditem_title"  :class="{a_active:activeIndex==1}" >
                    <img src="../assets/about.png" alt="项目介绍图标" style="vertical-align: middle; "><div><span style="letter-spacing: 0.2vh;">基本概述</span><br>About</div>
                    </div></div></td>
                  <td><div class="tditem" @click="clicktd(4)" :class="{tditem_active:activeIndex==4}"><div class="tditem_title"  :class="{a_active:activeIndex==4}" >
                    <img src="../assets/download.png" alt="数据下载图标" style="vertical-align: "><div><span style="letter-spacing: 0.2vh;">低碳解决方案</span><br>Case Show</div>
                    </div></div></td>
                </tr> 
            </table>
        </nav>
    </div>
    <!-- <div class="haederright">
        <div style="font-size:20px;text-align:start;">最新动态 Latest News</div>
        <ul>
            <li>2024-11-29: 新增了2024年度的数据更新。</li>
            <li>2024-11-28: 数据中心界面优化完成。</li>
            
        </ul>
    </div> -->
  </div>
</template>

<script>
export default {
 
    data() {
      return {
        activeIndex: 1,
        // routerutl:[
        //   '',
        //   '/indexpage',
        //   '/item',
        //   '/method',
        //   '/index',
        //   '/achi',
        //   '/download'
        // ]
        routerutl:[
          '',
          '/intr',
          '/method',
          '/index',
          '/download'
        ]
      };
    },
    computed: {
      currentRoute() {
       
        for(var i=1;i<this.routerutl.length+1;i++){
        if(this.$route.path==this.routerutl[i]){
          return i
        }
      }
      }
    },
    
    mounted(){
      console.log('当前路由路径:', this.$route.path);
      for(var i=1;i<this.routerutl.length+1;i++){
        if(this.$route.path==this.routerutl[i]){
          console.log(i)
          this.activeIndex=i
        }
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log('router to:'+this.routerutl[key]);
        this.$router.push(this.routerutl[key]);
      },
      clicktd(id){
        var path=this.$route.path;
        console.log(this.$route.path);
        var flag=sessionStorage.getItem('loginStatus') || '0';
        //console.log(flag);
        if(flag === '0'){
          if(path!='/intr/indexpage')
            this.$router.push('/intr/indexpage');
          this.$message({
            showClose: true,
            message: '请登录后访问',
            type: 'warning'
           });
        }
        else if((id!=this.activeIndex)&&(this.$route.path!=this.routerutl[id])){
          this.$router.push(this.routerutl[id])
            .then(() => {
              this.activeIndex=id
              console.log('导航成功完成');
          })
          .catch(error => {
            console.error('导航被阻止或出错:', error);
          });
          
        }
         
      },
      login(){
        this.$store.commit('setLoginDialog', true); 
        console.log('dologin')
      },
      logout(){
        console.log('dologout')
        localStorage.setItem('loginStatus', '0');
        sessionStorage.setItem('loginStatus', '0');
        this.$store.commit('setSessionLoginStatus', '0'); 
        this.$message({
            showClose: true,
            message: '已退出登录',
            type: 'success'
           });
      }
    }
  }
</script>


<style>
.head{
  display: flex;
  top: 0px;
  /* position: absolute; */
  height: 80px;
  background-color: #303643;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.dvmsmenu {
  height: 100%;
  background-color: #303643  !important;
}
.menuitem{
  height: 100% !important;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #303643  !important;
  font-size: 20px !important;
}
.menuitem:hover{
  color:#ffffff !important;
}
.headerback .el-menu-item.is-active{
  color:#ffffff !important;
}


.headerback{

  background-color: rgba(29, 70, 107, 1);
  display: flex;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 16.6vh;
}
.headerleft{
  background-color: #1d466b;
  width: 100%;
  
}
.haederright{
  background-color: #1a3d5e;
  width: 50%;
  height: 150px;
  border-radius: 10px;
  border: #193c5b solid 3px;
  padding: 15px;
  color: white; 
}
.haederright ul{
  text-align: start;
}
.haederright li{
  /* margin-bottom:5px ; */
}
.title {
  margin-top: 1vh;
  margin-bottom: 0.5vh;
    height: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 4.5vh; /* 根据需要调整字体大小 */
    color: #ffffff;
    width: 100%;
}
.navbar-container {
    background: #1d466b;
    color: white;
    padding: 0px;
}

.navbar {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
}
.navbar table td{
  display: flex;
  justify-content: center;
  align-items: center;
}
.navbar td{

  height: 100%;
  width: 16.6%;
}

.navbar a {
    display: flex;
    align-items: center;
    font-size: 3vh; /* 根据需要调整字体大小 */
    color: white;
    text-decoration: none;
    padding: 0px;
}

.navbar  img {
    width: 4vh; /* 图标大小与字体大小一致 */
    height: 4vh;
    margin-right: 1vh;
    vertical-align: middle;
}

.headerback .tditem:hover {
    cursor: pointer;
    background: white !important; /* 悬停时背景色变为白色 */
    
    border-radius: 2vh; /* 添加圆角效果 */
    transition: background 0.3s, color 0.3s; /* 平滑过渡效果 */
}
.headerback .tditem:hover div{
  color: #1d466b !important; /* 悬停时字体颜色变为背景色 */
  font-weight: 600;
}

.tditem_title{
  display: flex;
  justify-content: center;
  align-items: center;
}
.headerback .tditem_active {
    
    display: flex;
    justify-content: center;
    align-items: center;
    background: white !important; /* 悬停时背景色变为白色 */
    border-radius: 2vh; /* 添加圆角效果 */
    transition: background 0.3s, color 0.3s; /* 平滑过渡效果 */
}
.headerback .a_active{
  color: #1d466b !important; /* 悬停时字体颜色变为背景色 */
  font-weight: 600;
}
.headerback .tditem{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1vh 0;
  height: 80%;
  width: 90%;
  font-size: 2.3vh;
  
}
.el-tooltip__popper .logoutbutton{
  cursor: pointer;
}
.el-tooltip__popper .logoutbutton :hover{
  color: #fff;
}

/* a.router-link-exact-active,
a.router-link-active,
.router-link-exact-active,
.router-link-active {
  text-decoration: none;
} */



</style>